import * as React from "react";
import { Loader2 } from "lucide-react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/utils";

/**
 * Spinner — basis extension (no canonical shadcn component, like the success/warning/info Alert
 * variants). A loading indicator that inherits the current text color (`text-current`), so it
 * sits correctly inside buttons, alerts, and inline text without any color token of its own.
 *
 * See also: the `loading` prop on <Button>, which renders this.
 */
const spinnerVariants = cva("animate-spin text-current", {
  variants: {
    size: { sm: "size-4", default: "size-5", lg: "size-6" },
  },
  defaultVariants: { size: "default" },
});

function Spinner({
  className,
  size,
  "aria-label": ariaLabel = "Loading",
  ...props
}: React.ComponentProps<typeof Loader2> & VariantProps<typeof spinnerVariants>) {
  return (
    <Loader2
      data-slot="spinner"
      role="status"
      aria-label={ariaLabel}
      className={cn(spinnerVariants({ size }), className)}
      {...props}
    />
  );
}

export { Spinner, spinnerVariants };
